<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/I6qU4R/tc-custom/9781426824135.jpg?1704825536846" alt="This image is the cover for the book Christmas She Always Wanted, Men of the West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas She Always Wanted, Men of the West
      </h1>
      <p class="bookDescription body article font2">
        <p>Single mom Angie Malone left Christmas wishes to her daughter. After all, Santa couldn't fix the broken heart Angie'd had since Jubal Jamison married another woman. She had never seen Jubal againnot even to say she was carrying his child.<br/><br/>But now a miracle might happen for Angie and her little girl. With Jubal hired as the vet for the Sandbur Ranch, there was a chance for father and daughter to find each other. And with Christmas just around the corner, perhaps Jubal and Angie could finally forgive the pastand become the family they'd always wanted to be.<br/><br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stella Bagwell
      </h2>
      
      <p class="authorDescription body article">The author of over seventy-five titles for Harlequin, Stella Bagwell writes about familes, the West, strong, silent men of honor and the women who love them. She credits her loyal readers and hopes her stories have brightened their lives in some small way. A cowgirl through and through, she recently learned how to rope a steer. Her days begin and end helping her husband on their south Texas ranch. In between she works on her next tale of love. Contact her at stellabagwell@gmail.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin Enterprises
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?28509125